import { QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from './AuthProvider';
import { theme } from '../config/theme';
import { queryClient } from '../services/query-client';

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ConfigProvider theme={theme}>
          <AuthProvider>{children}</AuthProvider>
        </ConfigProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};
